import { Component, ViewEncapsulation, OnInit, Input, ViewChild, forwardRef, OnChanges, SimpleChanges, Output, EventEmitter, ComponentRef, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { NpDatePickerService, DayDataPerMonth } from "./date-picker.service";
import * as moment_ from 'moment'; const moment = moment_
import { OverlayRef } from "@angular/cdk/overlay";
import { NpDatePickerPopup } from "./components/date-picker-popup";
import { ComponentPortal } from "@angular/cdk/portal";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "./date-picker-const";
import { NpInput } from "../input";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { DatePickerFooterItem } from "./components/date-picker-footer";

/**
 * Date pickerç»ä»¶
 */
@Component({
  selector: `np-date-picker`,
  templateUrl: 'date-picker.html',
  styleUrls: ['date-picker.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpDatePicker),
      multi: true,
    }
  ]
})

export class NpDatePicker implements OnInit, OnChanges, ControlValueAccessor {

  /**æ ç­¾ */
  @Input() label: string;
  /**æ¯å¦å¿å¡«ï¼trueä»å¨æ ç­¾åé¢æ·»å çº¢è²*å·ï¼ falseä¸å */
  @Input() isRequired: boolean;
  /**Placeholder */
  @Input() placeholder: string = '';
  /**æ ¡éªéè¯¯æ¶æ¾ç¤ºéè¯¯ä¿¡æ¯ */
  @Input() errorMessage: string;
  /**æ¯å¦ç¦ç¨ */
  @Input() isDisabled: boolean;

  /**å·²éæ¶é´ */
  @Input() date: moment_.Moment | string = null;
  /**æ¥ææ¶é´å±ç¤ºæ ¼å¼ï¼é»è®¤åªå±ç¤ºæ¥æ */
  @Input() format: string = DATE_FORMAT;
  /**æ¯å¦å±ç¤ºæ¶é´ï¼é»è®¤ä¸å±ç¤º */
  @Input() isShowTime: boolean = false;
  /**æ¾ç¤ºå¨footerå·¦ä¾§çèªå®ä¹æ¶é´æ ç­¾æ°ç»ï¼å¦âæ¨å¤©âç­ */
  @Input() footerItems: DatePickerFooterItem[] = [];
  /**å½ä¸ºdatetime-pickeræ¶ï¼åºé¨é¢æ¿æå³ä¾§å±ç¤ºçç¡®è®¤æé®åç§° */
  @Input() confirmButtonText: string = 'ç¡®è®¤';

  @Output() onDateChanged = new EventEmitter<any>();

  @ViewChild('datePickerInput') datePickerInput: NpInput;
  datePickerPopupRef: ComponentRef<NpDatePickerPopup>;

  private overlayRef: OverlayRef;
  isHover: boolean = false;

  private emitChange = (_: any) => { };

  /**æ¥æè¾å¥æ¡ææ¬å¼ï¼æ¯å½this.dateæ¹åæ¶æ­¤å¼ä¼åæ­¥æ¹å*/
  value: string;

  constructor(private datePickerService: NpDatePickerService, private cdf: ChangeDetectorRef) { }

  ngOnInit() {
    this.overlayRef = this.datePickerService.getOverlayRef(this.datePickerInput.npInput);

    if (this.isShowTime) {
      this.format = DATE_TIME_FORMAT;
    }
  }

  ngOnChanges(changes: SimpleChanges): void { }

  onToggleDatePickerPopup() {
    if (this.isDisabled) {
      return;
    }

    if (this.overlayRef.hasAttached()) {
      this.closePopup();
      return;
    }

    this.datePickerPopupRef = this.overlayRef.attach(new ComponentPortal(NpDatePickerPopup));
    this.datePickerPopupRef.instance.date = moment(this.date);
    this.datePickerPopupRef.instance.datePickerType = this.isShowTime ? 'datetime-picker' : 'date-picker';
    this.datePickerPopupRef.instance.footerItems = this.footerItems;
    this.datePickerPopupRef.instance.isShowTime = this.isShowTime;
    this.datePickerPopupRef.instance.confirmButtonText = this.confirmButtonText;
    this.subscribeNotifyEvents();

    this.overlayRef.backdropClick().subscribe(() => {
      this.closePopup();
    });
  }

  onBlur(data: { value: any, event: any }) {
    if (this.datePickerService.isValid(data.value)) {
      this.date = moment(data.value, this.format).clone();
    } else {
      // å¦æè¾å¥æ¥æä¸åæ³ï¼é»è®¤å½åæ¶é´
      this.date = moment().clone();
    }

    this.syncValue();
    this.emitChange(this.date);
    this.onDateChanged.emit(this.date);
  }

  onClear() {
    if (this.isDisabled) {
      return;
    }

    this.date = null;
    this.syncValue();
    this.emitChange(this.date);
    this.onDateChanged.emit(this.date);
  }

  onMouseenter() {
    this.isHover = true;
  }

  onMouseleave() {
    this.isHover = false;
  }

  //#region Private methods

  /**æ¯æ¬¡this.dateæ¹åæ¶ï¼è¿ä¸ªæ¹æ³é½å¿é¡»è¦è°ç¨ */
  private syncValue() {
    if (this.date && this.datePickerService.isValid(this.date)) {
      this.value = moment(this.date, this.format).format(this.format);
    } else {
      this.value = '';
    }
  }

  private closePopup() {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  private subscribeNotifyEvents() {
    this.datePickerPopupRef.instance.onDayClicked.subscribe((res: DayDataPerMonth) => {
      this.emitDataAndClosePopup(res.date);
    });

    this.datePickerPopupRef.instance.onItemLabelClicked.subscribe((res: DatePickerFooterItem) => {
      if (res.value instanceof Function) {
        this.emitDataAndClosePopup(res.value());
      } else {
        this.emitDataAndClosePopup(moment(res.value));
      }

      this.closePopup();
    });

    if (this.isShowTime) {
      this.datePickerPopupRef.instance.onTimeClicked.subscribe((res: string) => {
        let date = moment(moment(this.date).format(DATE_FORMAT) + ' ' + res);
        this.emitDataAndClosePopup(date);
      });

      this.datePickerPopupRef.instance.onConfirmClicked.subscribe((res: string) => {
        let date = moment(moment(this.date).format(DATE_FORMAT) + ' ' + res);
        this.emitDataAndClosePopup(date);
        this.closePopup();
      });
    }
  }

  private emitDataAndClosePopup(date: moment_.Moment) {
    this.date = date;
    this.syncValue();
    this.emitChange(moment(this.date));
    this.onDateChanged.emit(moment(this.date));
    this.datePickerInput.focus();
    if (!this.isShowTime) {
      this.closePopup();
    }
  }
  //#endregion

  //#region Implement for ControlValueAccessor
  writeValue(obj: any): void {
    this.date = obj;
    this.syncValue();
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }
  //#endregion
}